import { AppRegistry } from 'react-native';
import App from './App';

AppRegistry.registerComponent('GuidedVerses', () => App);
AppRegistry.runApplication('GuidedVerses', {
  rootTag: document.getElementById('root'),
});
